import {
  Button,
  Container,
  Dialog,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField,
  Box
} from '@mui/material';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {
  dropdownFetch,
  getCityByState,
  getCurrentDateTime,
  getKeyPathValue,
  getStatesByCountry,
  request,
  toast
} from '../../../../../utils';
import { useCallback, useEffect, useRef, useState } from 'react';
import { GENDER_DROPDOWN, RECEIPT_MODE, APPOINTMENT_SERVICE, REG_LOCATION } from '../../../../../constants/dropdown';
import { CustomButtonn } from '../../../../../components';
import { useLocation } from 'react-router-dom';

const TABLE_COLUMNS = [
  { header: 'App. No.', accessor: 'app_no' },
  {
    header: 'Patient Name ',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row.patient_name}`}
        </span>
      );
    }
  },
  { header: 'Gender', accessor: 'gender' },
  { header: 'Mobile No.', accessor: 'mobile' },
  { header: 'Status', accessor: 'status', sx: { textTransform: 'uppercase' } }
];

const initialAppointmentBookingDataObj = {
  data: [],
  loading: false
};

export const AppointmentBooking = () => {
  const [loading, setLoading] = useState(false);
  const [appointmentBookingDataObj, setAppointmentBookingDataObj] = useState(initialAppointmentBookingDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const [searchData, setSearchData] = useState([]);
  const [input, setInput] = useState('');
  const [isFiltered, setIsFiltered] = useState(false);
  const [stateName, setStateName] = useState([]);
  const [cityName, setCityName] = useState([]);
  const [sponsorDropdown, setSponsorDropdown] = useState([]);
  const [doctorDropdown, setDoctorDropdown] = useState([]);
  const [departmentDropdown, setDepartmentDropdown] = useState([]);
  const [doctorFeeData, setDoctorFeeSetup] = useState([]);
  const [opdTypeDropdown, setopdTypeDropdown] = useState([]);
  const { getValues } = useForm();
  const user = JSON.parse(localStorage.getItem('user'));

  const fieldOneRef = useRef(null);
  const fieldTwoRef = useRef(null);
  const fieldThreeRef = useRef(null);
  const fieldFourRef = useRef(null);
  const fieldFiveRef = useRef(null);
  const fieldSixRef = useRef(null);
  const fieldSevenRef = useRef(null);
  const fieldEightRef = useRef(null);

  const handleKeyPress = (e, nextFieldRef) => {
    if (e.key === 'Tab' && nextFieldRef) {
      e.preventDefault();
      nextFieldRef.current.focus();
    }
  };

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        patient_name: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      availability: new Date().toISOString().split('T')[0],
      date: new Date().toISOString().split('T')[0],
      time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5),
      country: 'IN',
      total: 0,
      recd: 0,
      bal: 0,
      gender: 'Male',
      service: 'Consultancy',
      receipt_mode: 'CASH',
      location: 'Hospital'
    },
    mode: 'all'
  });
  const { handleSubmit, watch, setValue, reset } = methods;
  useEffect(() => {
    if (selectedRecord) {
      console.log('HELLO SELECTED RECORD', selectedRecord);
      const keyValuePair = getKeyPathValue(selectedRecord, '', ['_id', 'status', '__v']);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      const formattedScFromDate = selectedRecord?.scheme_valid_from
        ? new Date(selectedRecord.scheme_valid_from).toISOString().split('T')[0]
        : '';
      setValue('scheme_valid_from', formattedScFromDate);
      const formattedScToDate = selectedRecord?.scheme_valid_to
        ? new Date(selectedRecord.scheme_valid_to).toISOString().split('T')[0]
        : '';
      setValue('scheme_valid_to', formattedScToDate);
      const formattedDate = selectedRecord?.date ? new Date(selectedRecord.date).toISOString().split('T')[0] : '';
      setValue('date', formattedDate);
      const formattedDobDate = selectedRecord?.dob ? new Date(selectedRecord.dob).toISOString().split('T')[0] : '';
      setValue('dob', formattedDobDate);
      setValue('image', selectedRecord?.image);
      setValue('scheme_name', selectedRecord?.scheme_name);
      if (selectedRecord.image) {
        const imageFileName = selectedRecord.image.split('\\').pop();
        const imageUrl = `${process.env.PUBLIC_URL}/${imageFileName}`;
      }
    } else {
      reset();
    }
  }, [setValue, reset, selectedRecord]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/appointment-update' : '/appointment-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        ...formValues,
        createdBy: user.name,
        updatedBy: editFlag ? user.name : '',
        organisation
      }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'edited' : 'created'} Appointment`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
      setSelectedRecord();
    } else {
      toast(`Failed to ${editFlag ? 'edit' : 'create'} Appointment`, { variant: 'error' });
    }
    setLoading(false);
  };

  const sponsorWatch = watch('category');
  const consultantWatch = watch('doctor');
  const opdTypeWatch = watch('opd_type');

  useEffect(() => {
    if (!sponsorWatch || !consultantWatch || !opdTypeDropdown) return;
    const opdFeeType = doctorFeeData.filter(
      (data) => data.doctor === consultantWatch && data.sponsor === sponsorWatch
    )[0]?.opd_type_fee;
    if (!opdFeeType) return;
    const selectedOpdType = opdFeeType.filter(({ opd_type }) => opd_type === opdTypeWatch)[0];
    console.log('HELLLO SELECTEDOPD TYPE', selectedOpdType);
    if (!selectedOpdType) {
      setValue('total', 0);
      setValue('recd', 0);
      setValue('bal', 0);
    } else {
      setValue('total', selectedOpdType?.amount);
      setValue('recd', selectedOpdType?.amount);
      setValue('bal', selectedOpdType?.discount);
    }
  }, [sponsorWatch, consultantWatch, opdTypeWatch, doctorFeeData]);

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/appointment-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully cancel Appointment Booking', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to cancel Appointment Booking', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/appointment-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Appointment Booking', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Appointment Booking', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setAppointmentBookingDataObj({ loading: true });
    const response = await request('/appointment-list', { method: 'GET' });
    const sortedData = response.data.sort((a, b) => b.app_no - a.app_no);
    const filteredData = sortedData.filter(
      (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
    );
    if (response.success) {
      setAppointmentBookingDataObj({ loading: false, data: filteredData });
      setSearchData(filteredData);
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setAppointmentBookingDataObj({ loading: false });
    }
  };



  useEffect(() => {
    handleSearch();
  }, [input]);

  const handleSearch = async() => {
    const lowercasedInput = input.toLowerCase().trim();
    const limit = 10;
    try {
      const response = await request('/appointment-list', {
        method: 'GET',
        query: { name: lowercasedInput , limit : limit}
      });
      if (response.success && Array.isArray(response.data)) {
        setAppointmentBookingDataObj({ loading: false, data: response.data });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setAppointmentBookingDataObj({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setAppointmentBookingDataObj({ loading: false, data: [] });
    }
  };

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };

  const getStateDropdown = useCallback(async () => {
    const data = await dropdownFetch('state');
    if (!selectedRecord) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      setValue('state', defaultState?._id);
    }
    setStateName(data);
  }, []);
  const getCityDropdown = useCallback(async () => {
    const data = await dropdownFetch('city');
    if (!selectedRecord) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      setValue('city', defaultState?._id);
    }
    setCityName(data);
    console.log('Hello City', cityName);
  }, []);

  const getSponsorDropdown = useCallback(async () => {
    const data = await dropdownFetch('sponsor');
    if (!selectedRecord) {
      const [defaultSponsor] = data.filter(({ status }) => status === 'default');
      setValue('category', defaultSponsor?._id);
    }
    setSponsorDropdown(data);
  }, []);

  const getDoctorDropdown = useCallback(async () => {
    const data = await dropdownFetch('doctor');
    if (!selectedRecord && !getValues('doctor')) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      setValue('doctor', defaultState?._id);
      if (defaultState) {
        setValue('department', defaultState.qualification_details.department);
      }
    }
    setDoctorDropdown(data);
  }, [selectedRecord, getValues, setValue]);

  const getopdTypeDropdown = useCallback(async () => {
    const data = await dropdownFetch('opd-type');
    if (!selectedRecord) {
      const [defaultOpdType] = data.filter(({ status }) => status === 'default');
      setValue('opd_type', defaultOpdType?._id);
    }
    setopdTypeDropdown(data);
  }, []);

  const getDepartmentDropdown = useCallback(async () => {
    const data = await dropdownFetch('department');
    setDepartmentDropdown(data);
  }, []);

  const getDoctorFeeData = useCallback(async () => {
    const data = await dropdownFetch('doctor-fee-setup');
    setDoctorFeeSetup(data);
  }, []);

  useEffect(() => {
    getCityDropdown();
    getStateDropdown();
    getSponsorDropdown();
    getDoctorDropdown();
    getDepartmentDropdown();
    getopdTypeDropdown();
    getDoctorDropdown();
    getDoctorFeeData();
  }, [
    getCityByState,
    getStateDropdown,
    getSponsorDropdown,
    getDoctorDropdown,
    getDepartmentDropdown,
    getopdTypeDropdown,
    getDoctorFeeData
  ]);

  const ageYearWatch = watch('age_year');
  useEffect(() => {
    const currentDate = new Date();
    currentDate.setFullYear(currentDate.getFullYear() - ageYearWatch);
    setValue('dob', getCurrentDateTime('date', currentDate).split('-').reverse().join('-'));
  }, [ageYearWatch, setValue]);

  const mobile = watch('mobile');
  const isRqtyInvalid = 10 >= mobile; 

  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            minWidth: '100%'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Appointment Booking
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord('');
                    setCurrentAction('new');
                    reset('');
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  disabled={!selectedRecord || currentAction}
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '80%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Patient Name</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.7, border: currentAction ? '0.5px solid red' : '' }}
                    name="patient_name"
                    placeholder=" Enter Patient Name"
                    inputRef={fieldOneRef}
                    onKeyDown={(e) => handleKeyPress(e, fieldTwoRef)}
                  />
                </Stack>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Date/Time</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.35, border: currentAction ? '0.5px solid red' : '' }}
                    name="date"
                    type="date"
                  />
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.35, border: currentAction ? '0.5px solid red' : '' }}
                    name="time"
                    type="time"
                  />
                </Stack>
              </Stack>
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1.4rem' }}>Age/Gender</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.2, border: currentAction ? '0.5px solid red' : '' }}
                    name="age_year"
                    placeholder="Enter Age"
                    inputRef={fieldThreeRef}
                    onKeyDown={(e) => handleKeyPress(e, fieldFourRef)}
                  />
                  <TextField disabled sx={{ flex: 0.3 }} type="date" name="dob" />
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.3, border: currentAction ? '0.5px solid red' : '' }}
                    name="gender"
                    placeholder="Select Gender"
                    menus={GENDER_DROPDOWN}
                    inputRef={fieldTwoRef}
                    onKeyDown={(e) => handleKeyPress(e, fieldThreeRef)}
                  />
                </Stack>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Country</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.7 }}
                    menus={[{ _id: 'IN', name: 'India' }]}
                    name="country"
                  />
                </Stack>
              </Stack>
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>State</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.7 }}
                    name="state"
                    // menus={getStatesByCountry(watch('country'))}
                    menus={[
                      ...(getStatesByCountry(watch('address.country')) || []),
                      ...stateName.map((data) => ({ ...data, name: data.state }))
                    ]}
                  />
                </Stack>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>City</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.7 }}
                    name="city"
                    // menus={getCityByState(watch('country'), watch('state'))}
                    menus={[
                      ...(getCityByState(watch('address.country'), watch('address.state')) || []),
                      ...cityName.map((data) => ({ ...data, name: data.city }))
                    ]}
                  />
                </Stack>
              </Stack>
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Address</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.7, border: currentAction ? '0.5px solid red' : '' }}
                    name="address"
                    placeholder="Address"
                    inputRef={fieldFourRef}
                    onKeyDown={(e) => handleKeyPress(e, fieldFiveRef)}
                  />
                </Stack>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Location</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.7 }}
                    name="location"
                    placeholder="Select Location"
                    menus={REG_LOCATION}
                  />
                </Stack>
              </Stack>
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Doctor</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.7, border: currentAction ? '0.5px solid red' : '' }}
                    name="doctor"
                    placeholder="Select Doctor"
                    inputRef={fieldFiveRef}
                    onKeyDown={(e) => handleKeyPress(e, fieldSixRef)}
                    menus={doctorDropdown}
                    onChange={({ target: { row } }) => {
                      setValue('department', row.qualification_details.department);
                    }}
                  />
                </Stack>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Department</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.7, border: currentAction ? '0.5px solid red' : '' }}
                    name="department"
                    placeholder="Select Department"
                    inputRef={fieldSixRef}
                    onKeyDown={(e) => handleKeyPress(e, fieldSevenRef)}
                    menus={departmentDropdown.map((data) => ({ ...data, name: data.department }))}
                  />
                </Stack>
              </Stack>

              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Mobile</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    type="number"
                    sx={{ flex: 0.7, border: currentAction ? '0.5px solid red' : '' }}
                    name="mobile"
                    placeholder="Enter Mobile"
                    inputRef={fieldSevenRef}
                    onKeyDown={(e) => handleKeyPress(e, fieldOneRef)}
                    error={isRqtyInvalid || (mobile && mobile.length !== 10)}
                    helperText={
                      isRqtyInvalid
                        ? 'Mobile number must be exactly 10 digits'
                        : mobile && mobile.length !== 10
                          ? 'Mobile number must be exactly 10 digits'
                          : ''
                    }
                    inputProps={{ maxLength: 10 }}
                    onInput={(e) => {
                      if (e.target.value.length > 10) {
                        e.target.value = e.target.value.slice(0, 10);
                      }
                    }}
                  />
                </Stack>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Catgeory</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.7 }}
                    name="category"
                    placeholder="Select Category"
                    menus={sponsorDropdown}
                  />
                </Stack>
              </Stack>

              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Service</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.7 }}
                    name="service"
                    placeholder="Select Service"
                    menus={APPOINTMENT_SERVICE}
                  />
                </Stack>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>OPD Type</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.7 }}
                    name="opd_type"
                    menus={opdTypeDropdown.map((data) => ({ ...data, name: data.type }))}
                  />
                </Stack>
              </Stack>
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Total/Recd/Bal</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.25 }}
                    name="total"
                    type="number"
                  />
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.25 }}
                    name="recd"
                    type="number"
                  />
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.2 }}
                    name="bal"
                    type="number"
                  />
                </Stack>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Receipt Mode</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.7 }}
                    name="receipt_mode"
                    placeholder="Select Receipt Mode"
                    menus={RECEIPT_MODE}
                  />
                </Stack>
              </Stack>
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Cheque/Card No</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.7 }}
                    name="cheque_no"
                    placeholder="Enter Cheque/Card No."
                  />
                </Stack>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Ramarks</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.7 }}
                    name="remarks"
                    placeholder="Enter Remarks"
                  />
                </Stack>
              </Stack>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Appointment Booking Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '14px'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 14px'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Enter Patient Name"
            placeholder="Enter Patient Name"
            variant="outlined"
            value={input}
            onChange={handleChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_COLUMNS}
          data={appointmentBookingDataObj?.data || []}
          loading={appointmentBookingDataObj.loading}
          onRowClick={(row) => {
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
    </>
  );
};
